<div class="fatura-card">
  <div class="card-header">
    <i class="pi pi-file"></i>
    <span>{{ texts.fatura_eletronica }}</span>
  </div>

  <p-progressBar [value]="progresso" [showValue]="false" styleClass="progresso-bar"></p-progressBar>

  <p-divider></p-divider>

  <div class="etapa" (click)="irParaConfigEmpresa()">
    <i class="pi"
       [class.pi-check-circle]="temDadosEmpresa"
       [class.pi-circle]="!temDadosEmpresa"
       [class.concluido]="temDadosEmpresa"></i>
    <span>{{ texts.dados_empresa }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>

  <div class="etapa" (click)="irParaConfigEmpresa()">
    <i class="pi"
       [class.pi-check-circle]="temCertificadoDigital"
       [class.pi-circle]="!temCertificadoDigital"
       [class.concluido]="temCertificadoDigital"></i>
    <span>{{ texts.certificado_digital }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>

  <div class="etapa" (click)="irParaTimbrado()">
    <i class="pi"
       [class.pi-check-circle]="temTimbradoEletronico"
       [class.pi-circle]="!temTimbradoEletronico"
       [class.concluido]="temTimbradoEletronico"></i>
    <span>{{ texts.timbrado_eletronico }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>

  <div class="etapa" (click)="irParaVendas()">
    <i class="pi"
       [class.pi-check-circle]="temVendaTimbrado"
       [class.pi-circle]="!temVendaTimbrado"
       [class.concluido]="temVendaTimbrado"></i>
    <span>{{ texts.venda_timbrado }}</span>
    <i class="pi pi-angle-right ml-auto"></i>
  </div>

  <div class="acoes">
    <button pButton type="button"
            [label]="texts.nao_mostrar_mais"
            class="p-button-text p-button-sm"
            icon="pi pi-times"
            (click)="onDismiss()">
    </button>
  </div>
</div>
